import { Model } from '@/models/Model'
import Property from '@/decorators/Property'

export class VhfChannel extends Model {
	protected jsonApiType = 'vhfChannels'

	@Property()
	public vhfChannel!: string
}
